import { render, staticRenderFns } from "./ClientEditRejectRecord.vue?vue&type=template&id=156a95ce&scoped=true&"
import script from "./ClientEditRejectRecord.vue?vue&type=script&lang=js&"
export * from "./ClientEditRejectRecord.vue?vue&type=script&lang=js&"
import style0 from "./ClientEditRejectRecord.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ClientEditRejectRecord.vue?vue&type=style&index=1&id=156a95ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156a95ce",
  null
  
)

export default component.exports